import { LoginForm } from "@/app/login/login-form/LoginForm"

type LoginViewProps = {
  onLogin: (email: string) => Promise<void>
  isLoading: boolean
  errorMessage: string | null
}

export function Login({ onLogin, isLoading, errorMessage }: LoginViewProps) {
  return (
    <div className="relative grid min-h-svh bg-muted/30 md:grid-cols-2">
      <img
        src="/assets/cloudfit-logo.png"
        alt="CloudFit Software"
        className="absolute left-6 top-6 z-10 h-10 w-auto md:h-12"
        loading="lazy"
      />
      <div className="flex items-center justify-center p-6 md:p-10">
        <div className="w-full max-w-sm">
          <LoginForm onLogin={onLogin} isLoading={isLoading} errorMessage={errorMessage} />
        </div>
      </div>
      <div className="relative hidden md:block">
        <img
          src="/assets/login-team.jpg"
          alt="CloudFit team"
          className="absolute inset-0 h-full w-full object-cover"
          loading="lazy"
        />
      </div>
    </div>
  )
}
